<template>
  <QuoteAcceptanceDialog
    :entity="entity"
    :display="displayQuoteAcceptance"
    :accepting="acceptingQuote"
    :opened-privacy-document="Boolean(privacyDocumentOpenedDate)"
    :accepted-quote-privacy-document="Boolean(privacyDocumentAcceptedDate)"
    :opened-terms-document="Boolean(termsDocumentOpenedDate)"
    :accepted-quote-terms-document="Boolean(termsDocumentAcceptedDate)"
    :opened-lease-document="Boolean(leaseDocumentOpenedDate)"
    :accepted-lease-document="Boolean(leaseDocumentAcceptedDate)"
    :enable-final-acceptance="enableFinalAcceptance"
    :loading-quote-pdf="loadingQuotePDF"
    :fbt-tax-exemption="fbtTaxExemption"
    @open:privacy-statement="openPrivacyStatement"
    @update:privacy-document-acceptance="
      setDocumentAcceptance('privacyDocumentAcceptedDate', $event)
    "
    @open:terms-and-conditions="openTermsAndConditions"
    @update:terms-document-acceptance="
      setDocumentAcceptance('termsDocumentAcceptedDate', $event)
    "
    @open:lease-document="openLeaseDocument"
    @update:lease-document-acceptance="
      setDocumentAcceptance('leaseDocumentAcceptedDate', $event)
    "
    @close:acceptance-dialog="setState(['displayQuoteAcceptance', $event])"
    @accept:accept-dialog="processQuoteAccepted"
  />
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import { getEnv, getAsset, getTheme } from 'ecx.saigon.ui.common';

export default {
  name: 'QuoteAcceptanceWidget',
  data() {
    return {
      creditCheckRoute: undefined
    };
  },
  computed: {
    ...mapState({
      fbtTaxExemption: (state) => state.quote.quote?.novated?.fbtTaxExemption,
      user: (state) => state.user.user,
      quotePDFHref: (state) => state.quote.quotePDFHref,
      loadingQuotePDF: (state) => state.quote.loadingQuotePDF,
      acceptingQuote: (state) => state.quote.acceptingQuote,
      displayQuoteAcceptance: (state) => state.quote.displayQuoteAcceptance,
      privacyDocumentOpenedDate: (state) =>
        state.quote.privacyDocumentOpenedDate,
      privacyDocumentAcceptedDate: (state) =>
        state.quote.privacyDocumentAcceptedDate,
      termsDocumentOpenedDate: (state) => state.quote.termsDocumentOpenedDate,
      termsDocumentAcceptedDate: (state) =>
        state.quote.termsDocumentAcceptedDate,
      leaseDocumentOpenedDate: (state) => state.quote.leaseDocumentOpenedDate,
      leaseDocumentAcceptedDate: (state) =>
        state.quote.leaseDocumentAcceptedDate
    }),
    ...mapGetters('user', ['getBrandDocuments', 'theme']),
    enableFinalAcceptance() {
      return Boolean(
        this.leaseDocumentAcceptedDate &&
          this.termsDocumentAcceptedDate &&
          this.privacyDocumentAcceptedDate
      );
    },
    entity() {
      const theme = getTheme(this.user.entity);
      return theme.value.charAt(0).toUpperCase() + theme.value.slice(1);
    }
  },
  methods: {
    ...mapMutations('quote', ['setState']),
    ...mapActions('quote', ['acceptQuote', 'getQuotePDF']),
    async processQuoteAccepted() {
      try {
        await this.acceptQuote();
        window.location = this.creditCheckRoute;
      } catch (e) {}
    },
    setDocumentAcceptance(field, accepted) {
      this.setState([field, accepted ? new Date() : undefined]);
    },
    openUrl(url) {
      const win = window.open(url, '_blank');
      if (win && win.focus) {
        win.focus();
      }
    },
    async openPrivacyStatement() {
      this.setState(['privacyDocumentOpenedDate', new Date()]);
      const url = this.theme().defaultBrand?.legal?.privacyPolicyLink;
      this.openUrl(url);
    },
    async openLeaseDocument() {
      await this.getQuotePDF();
      this.setState(['leaseDocumentOpenedDate', new Date()]);
      this.openUrl(this.quotePDFHref);
    },
    async openTermsAndConditions() {
      this.setState(['termsDocumentOpenedDate', new Date()]);
      const url = await getAsset(this.getBrandDocuments.leaseTerms);
      this.openUrl(url);
    }
  },
  async beforeMount() {
    const env = await getEnv();
    this.creditCheckRoute = env.VUE_APP_CREDIT_CHECK_ROUTE;
  },
  components: {
    QuoteAcceptanceDialog: () =>
      import('../../components/organism/quote-acceptance-dialog')
  }
};
</script>
